export enum RolesEnum {
    Analista = 1,
    Supervisor = 2,
    VisualTrade = 3,
    Administrador = 4,
    AsesorPCs = 5,
    AsesorPCsDisabled = 6,
    MercaderistaAccesorios = 7,
    AsesorImpresion = 8,
    AsesorImpresionDisabled = 9,
    AsesorImpresionCISS = 10,
    AsesorImpresionCISSDisabled = 11,
    MercaderistaConsumibles = 12,
    AsesorPPS = 13,
    AsesorPPSDisabled = 14,
    MercaderistaMarcaCompartida = 15,
    LATAMTrainer = 16,
    LATAMAnalyst = 17,
    InStoreManager = 18,
    TradeManagerLATAM = 19,
    Publisher = 20,
    AsesorPCsCapturaMixta = 22,
    AsesorImpresionCapturaMixta = 23,
    AsesorImpresionCISSCapturaMixta = 24,
    MercaderistaConsumiblesCapturaMixta = 25,
    MercaderistaAccesoriosCapturaMixta = 26,
    MercaderistaMarcaCompartidaCapturaMixta = 27,
    Entrenador = 28,
    Coordinador = 29,
    BackOffice = 30,
    SupervisorDeConsulta = 31,
    CoordinadorDeConsulta = 32,
    PromotorPCsHPTiempoCompleto = 33,
    PromotorPCsHPMedioTiempo = 34,
    PromotorPCsHPMicrosoftJumpstarTiempoCompleto = 35,
    PromotorPCsHPMicrosoftJumpstarMedioTiempo = 36,
    PromotorPCsHPMicrosoftJMATiempoCompleto = 37,
    PromotorPCsHPMicrosoftJMAMedioTiempo = 38,
    PromotorPCsHPIntelTiempoCompleto = 39,
    PromotorPCsHPIntelMedioTiempo = 40,
    PromotorPCsHPAMDTiempoCompleto = 41,
    PromotorPCsHPAMDMedioTiempo = 42,
    MercaderistaHPAccesorios = 43,
    PromotorImpresionHPTiempoCompleto = 44,
    PromotorImpresionHPMedioTiempo = 45,
    PromotorImpresionPrgmHPTiempoCompleto = 46,
    PromotorImpresionPrgmHPMedioTiempo = 47,
    MercaderistaHPConsumibles = 48,
    PromotorPPSHPTiempoCompleto = 49,
    PromotorPPSHPMedioTiempo = 50,
    PromotorPPSHPMicrosoftJumpstarTiempoCompleto = 51,
    PromotorPPSHPMicrosoftJumpstarMedioTiempo = 52,
    PromotorPPSHPMicrosoftJMATiempoCompleto = 53,
    PromotorPPSHPMicrosoftJMAMedioTiempo = 54,
    PromotorPPSHPIntelTiempoCompleto = 55,
    PromotorPPSHPIntelMedioTiempo = 56,
    PromotorPPSHPAMDTiempoCompleto = 57,
    PromotorPPSHPAMDMedioTiempo = 58,
    SellOut = 59,
    MercaderistaHPImpresionHWYSupplies = 60,
    DemowareFullTimeHP = 61,
    DemowarePartTimeHP = 62,
    DemowareFullTimeHPAMD = 63,
    DemowarePartTimeHPAMD = 64,
    DemowareFullTimeHPMicrosoftJMA = 65,
    DemowarePartTimeHPMicrosoftJMA = 66,
    DemowareFullTimeHPIntel = 67,
    DemowarePartTimeHPIntel = 68,
    DemowareFullTimeHPMicrosoftJumpstar = 69,
    DemowarePartTimeHPMicrosoftJumpstar = 70,
    AgencyAdministrator = 71,
    CPFR = 72,
    HUBSupervisor = 75,
    HUBAgent = 76,
    RetailAssociate = 77,
    MercaderistaHPComputo = 78,
    Activators = 79,
    Merchandiser = 82,
    Promoter = 83,
    Demoware = 84
}
